import { apiFetch } from "./api";
import { stringifySnake } from "./serialization";

export function fetchVehicles() {
  return apiFetch("/api/v1/vehicles");
}

export function fetchVehicle(id) {
  return apiFetch(`/api/v1/vehicles/${id}`);
}

export function createVehicle(payload) {
  return apiFetch("/api/v1/vehicles", {
    method: "POST",
    body: stringifySnake(payload),
  });
}

export function updateVehicle(id, payload) {
  return apiFetch(`/api/v1/vehicles/${id}`, {
    method: "PATCH",
    body: stringifySnake(payload),
  });
}

export function deleteVehicle(id) {
  return apiFetch(`/api/v1/vehicles/${id}`, {
    method: "DELETE",
  });
}

export function uploadVehiclePhotos(id, photos) {
  return apiFetch(`/api/v1/vehicles/${id}/photos`, {
    method: "POST",
    body: stringifySnake({ photos }),
  });
}

export function deleteVehiclePhoto(id, resourceId) {
  return apiFetch(`/api/v1/vehicles/${id}/photos/${resourceId}`, {
    method: "DELETE",
  });
}
